export const HERO_IMAGE =
  "https://readdy.ai/api/search-image?query=Playful%20comic%20collage%20of%20funny%20cartoon%20characters%20laughing%20and%20making%20silly%20faces%2C%20flat%20vector%20illustration%20style%2C%20vibrant%20warm%20orange%20yellow%20and%20coral%20red%20color%20palette%2C%20energetic%20humorous%20composition%2C%20clean%20simple%20warm%20cream%20background%2C%20bold%20outlines%2C%20cheerful%20mood&width=1600&height=900&seq=yy-hero-2026&orientation=landscape";

export interface Collection {
  id: number;
  title: string;
  desc: string;
  tags: string[];
  views: string;
  likes: number;
  image: string;
}

export const collections: Collection[] = [
  {
    id: 1,
    title: "沙雕室友的迷惑日常",
    desc: "住在一起的第 380 天，室友每天都能整出新花样，笑得我肚子疼。",
    tags: ["沙雕日常", "室友", "合租"],
    views: "128.6万",
    likes: 32045,
    image:
      "https://readdy.ai/api/search-image?query=Silly%20cat%20cartoon%20character%20wearing%20a%20funny%20chef%20hat%20trying%20to%20cook%20pancakes%20in%20a%20messy%20kitchen%2C%20flat%20comic%20illustration%2C%20warm%20orange%20yellow%20and%20coral%20palette%2C%20humorous%20chaotic%20scene%2C%20simple%20clean%20warm%20background%2C%20bold%20outlines&width=800&height=600&seq=yy-col-1&orientation=landscape",
  },
  {
    id: 2,
    title: "打工人的周一精神状态",
    desc: "周一的我不叫打工人，我叫：还…还…还能再坚持一下下。",
    tags: ["神吐槽", "打工人", "职场"],
    views: "96.2万",
    likes: 27411,
    image:
      "https://readdy.ai/api/search-image?query=Cartoon%20office%20worker%20character%20sleeping%20at%20desk%20with%20coffee%20and%20flying%20papers%2C%20flat%20comic%20illustration%20style%2C%20warm%20orange%20yellow%20palette%2C%20funny%20relatable%20office%20humor%2C%20simple%20warm%20background%2C%20bold%20outlines&width=800&height=600&seq=yy-col-2&orientation=landscape",
  },
  {
    id: 3,
    title: "地铁上的灵魂画手",
    desc: "有人在车厢里安静看书，有人在车厢里安静整活，差距不是一点点。",
    tags: ["无厘头", "通勤", "日常"],
    views: "81.9万",
    likes: 19803,
    image:
      "https://readdy.ai/api/search-image?query=Two%20funny%20cartoon%20friends%20pulling%20each%20other%20chair%20for%20a%20silly%20prank%2C%20flat%20comic%20illustration%2C%20vibrant%20warm%20orange%20coral%20colors%2C%20playful%20energetic%20scene%2C%20simple%20warm%20cream%20background%2C%20bold%20outlines&width=800&height=600&seq=yy-col-3&orientation=landscape",
  },
  {
    id: 4,
    title: "爸妈迷惑行为图鉴",
    desc: "同一个世界，同一对爸妈。看完这组图，全家都沉默了。",
    tags: ["梗图", "家庭", "段子"],
    views: "74.5万",
    likes: 21007,
    image:
      "https://readdy.ai/api/search-image?query=Funny%20cartoon%20dog%20being%20chased%20by%20its%20own%20tail%20in%20a%20loop%2C%20flat%20comic%20illustration%2C%20warm%20orange%20yellow%20palette%2C%20absurd%20humor%20scene%2C%20simple%20warm%20background%2C%20bold%20outlines&width=800&height=600&seq=yy-col-4&orientation=landscape",
  },
];

export interface Category {
  id: number;
  name: string;
  en: string;
  count: string;
  desc: string;
  icon: string;
  color: string;
}

export const categories: Category[] = [
  {
    id: 1,
    name: "沙雕日常",
    en: "Silly Daily",
    count: "1,280 条",
    desc: "生活中那些离谱又好笑的小事",
    icon:
      "https://readdy.ai/api/search-image?query=Cartoon%20character%20laughing%20loudly%20with%20tears%20of%20joy%2C%20flat%20comic%20illustration%2C%20warm%20yellow%20orange%20palette%2C%20silly%20daily%20humor%2C%20simple%20warm%20background%2C%20bold%20outlines%2C%20square&width=600&height=600&seq=yy-cat-1&orientation=squarish",
    color: "primary",
  },
  {
    id: 2,
    name: "神吐槽",
    en: "Epic Roast",
    count: "960 条",
    desc: "一针见血，句句扎心的吐槽合集",
    icon:
      "https://readdy.ai/api/search-image?query=Cartoon%20character%20making%20a%20sarcastic%20smirk%20face%20giving%20thumbs%20down%2C%20flat%20comic%20illustration%2C%20warm%20orange%20palette%2C%20roasting%20commentary%20humor%2C%20simple%20warm%20cream%20background%2C%20bold%20outlines%2C%20square&width=600&height=600&seq=yy-cat-2&orientation=squarish",
    color: "accent",
  },
  {
    id: 3,
    name: "梗图段子",
    en: "Meme Jokes",
    count: "1,540 张",
    desc: "表情包与神梗，一图胜千言",
    icon:
      "https://readdy.ai/api/search-image?query=Funny%20cartoon%20character%20with%20exaggerated%20shocked%20surprised%20face%20pointing%2C%20flat%20comic%20illustration%2C%20warm%20coral%20orange%20palette%2C%20meme%20humor%2C%20simple%20warm%20background%2C%20bold%20outlines%2C%20square&width=600&height=600&seq=yy-cat-3&orientation=squarish",
    color: "secondary",
  },
  {
    id: 4,
    name: "无厘头剧场",
    en: "Absurd Theater",
    count: "720 集",
    desc: "没有逻辑，只有快乐的无厘头剧情",
    icon:
      "https://readdy.ai/api/search-image?query=Cartoon%20character%20rolling%20on%20floor%20laughing%20with%20sparkles%2C%20flat%20comic%20illustration%2C%20warm%20orange%20coral%20palette%2C%20absurd%20nonsensical%20humor%2C%20simple%20warm%20background%2C%20bold%20outlines%2C%20square&width=600&height=600&seq=yy-cat-4&orientation=squarish",
    color: "primary",
  },
];

export interface Rant {
  id: number;
  title: string;
  text: string;
  likes: number;
  replies: number;
  image: string;
}

export const rants: Rant[] = [
  {
    id: 1,
    title: "期末周前的我 vs 期末周后的我",
    text: "考前：不就一本书嘛，我一周能背完。考后：原来一周只有七天，是我格局小了。",
    likes: 12840,
    replies: 320,
    image:
      "https://readdy.ai/api/search-image?query=Funny%20cartoon%20student%20character%20panicking%20before%20exam%20with%20flying%20papers%2C%20flat%20comic%20illustration%2C%20warm%20orange%20palette%2C%20sarcastic%20roast%20humor%2C%20simple%20warm%20cream%20background%2C%20bold%20outlines%2C%20portrait&width=600&height=800&seq=yy-rant-1&orientation=portrait",
  },
  {
    id: 2,
    title: "健身房办了年卡之后",
    text: "办卡时幻想自己一身腱子肉，办卡后……我在家里把举铁的视频看了 200 遍，等于练了 200 遍。",
    likes: 10231,
    replies: 267,
    image:
      "https://readdy.ai/api/search-image?query=Cartoon%20character%20complaining%20on%20a%20phone%20call%20with%20annoyed%20face%20and%20steam%2C%20flat%20comic%20illustration%2C%20warm%20coral%20orange%20palette%2C%20roasting%20commentary%2C%20simple%20warm%20background%2C%20bold%20outlines%2C%20portrait&width=600&height=800&seq=yy-rant-2&orientation=portrait",
  },
  {
    id: 3,
    title: "网购的家具终于到了",
    text: "说明书：只需要三步。我：第一步拆箱，第二步看说明书，第三步……请师傅上门。",
    likes: 9345,
    replies: 198,
    image:
      "https://readdy.ai/api/search-image?query=Funny%20cartoon%20character%20trying%20to%20assemble%20flat-pack%20furniture%20with%20tangled%20parts%20everywhere%2C%20flat%20comic%20illustration%2C%20warm%20orange%20yellow%20palette%2C%20absurd%20humor%2C%20simple%20warm%20background%2C%20bold%20outlines%2C%20portrait&width=600&height=800&seq=yy-rant-3&orientation=portrait",
  },
  {
    id: 4,
    title: "月底的我打开钱包",
    text: "钱包：你没钱。我：不是，这只是你的一部分。钱包：你连一部分都没有。",
    likes: 15672,
    replies: 402,
    image:
      "https://readdy.ai/api/search-image?query=Cartoon%20character%20checking%20empty%20wallet%20with%20dramatic%20sad%20face%2C%20flat%20comic%20illustration%2C%20warm%20orange%20coral%20palette%2C%20relatable%20roast%20humor%2C%20simple%20warm%20background%2C%20bold%20outlines%2C%20portrait&width=600&height=800&seq=yy-rant-4&orientation=portrait",
  },
];

export interface Meme {
  id: number;
  title: string;
  category: string;
  likes: number;
  image: string;
}

export const memes: Meme[] = [
  {
    id: 1,
    title: "当老板说「就一个小改动」",
    category: "神吐槽",
    likes: 8210,
    image:
      "https://readdy.ai/api/search-image?query=Funny%20cartoon%20cat%20meme%20with%20a%20thinking%20bubble%2C%20flat%20comic%20illustration%2C%20warm%20orange%20palette%2C%20humorous%20meme%20scene%2C%20simple%20warm%20cream%20background%2C%20bold%20outlines&width=800&height=500&seq=yy-meme-1&orientation=landscape",
  },
  {
    id: 2,
    title: "我看了一眼银行卡余额",
    category: "沙雕日常",
    likes: 7410,
    image:
      "https://readdy.ai/api/search-image?query=Cartoon%20character%20making%20funny%20double-take%20expression%20turning%20head%2C%20flat%20comic%20illustration%2C%20warm%20coral%20orange%20palette%2C%20meme%20humor%2C%20simple%20warm%20background%2C%20bold%20outlines&width=800&height=500&seq=yy-meme-2&orientation=landscape",
  },
  {
    id: 3,
    title: "网速慢到怀疑人生",
    category: "无厘头剧场",
    likes: 6820,
    image:
      "https://readdy.ai/api/search-image?query=Funny%20cartoon%20robot%20with%20confused%20expression%20and%20question%20marks%2C%20flat%20comic%20illustration%2C%20warm%20yellow%20orange%20palette%2C%20nonsensical%20meme%20humor%2C%20simple%20warm%20background%2C%20bold%20outlines&width=800&height=500&seq=yy-meme-3&orientation=landscape",
  },
  {
    id: 4,
    title: "周末的我，谁也不认识",
    category: "梗图段子",
    likes: 9010,
    image:
      "https://readdy.ai/api/search-image?query=Cartoon%20character%20dancing%20awkwardly%20with%20headphones%2C%20flat%20comic%20illustration%2C%20warm%20orange%20coral%20palette%2C%20silly%20meme%20humor%2C%20simple%20warm%20background%2C%20bold%20outlines&width=800&height=500&seq=yy-meme-4&orientation=landscape",
  },
  {
    id: 5,
    title: "深夜点外卖的仪式感",
    category: "沙雕日常",
    likes: 5360,
    image:
      "https://readdy.ai/api/search-image?query=Funny%20cartoon%20character%20holding%20a%20giant%20sandwich%20about%20to%20bite%2C%20flat%20comic%20illustration%2C%20warm%20orange%20yellow%20palette%2C%20food%20meme%20humor%2C%20simple%20warm%20background%2C%20bold%20outlines&width=800&height=500&seq=yy-meme-5&orientation=landscape",
  },
  {
    id: 6,
    title: "凌晨三点的我是这样的",
    category: "无厘头剧场",
    likes: 7780,
    image:
      "https://readdy.ai/api/search-image?query=Cartoon%20character%20staring%20at%20screen%20with%20wide%20eyes%20at%20night%2C%20flat%20comic%20illustration%2C%20warm%20coral%20orange%20palette%2C%20late%20night%20meme%20humor%2C%20simple%20warm%20background%2C%20bold%20outlines&width=800&height=500&seq=yy-meme-6&orientation=landscape",
  },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "韩国歪歪漫画的内容多久更新一次？",
    a: "我们每天都会更新沙雕日常、神吐槽和梗图段子等新鲜内容，热门合集与无厘头剧场保持持续更新，保证每次打开都能刷到新的乐子。",
  },
  {
    q: "这些搞笑合集可以免费看吗？",
    a: "可以。韩国歪歪漫画的内容面向所有用户免费在线观看，不需要注册也能直接浏览大部分合集与段子，打开即看，找乐子零门槛。",
  },
  {
    q: "如何按分类找到我喜欢的搞笑内容？",
    a: "首页顶部设有沙雕日常、神吐槽、梗图段子、无厘头剧场等分类入口，点击即可快速进入对应专区，快速筛选出符合你口味的内容。",
  },
  {
    q: "网站支持手机和平板浏览吗？",
    a: "支持。韩国歪歪漫画采用响应式设计，无论用电脑、平板还是手机都能获得流畅的阅读体验，导航菜单在移动端也能正常展开收起。",
  },
  {
    q: "想投稿自己遇到的沙雕趣事，怎么联系？",
    a: "你可以通过页脚与联系板块的投稿邮箱发来你的趣事，也可以订阅更新留下邮箱，我们会定期把新鲜合集推送到你身边。",
  },
];

export interface Testimonial {
  name: string;
  role: string;
  text: string;
  star: number;
}

export const testimonials: Testimonial[] = [
  {
    name: "每天都想笑",
    role: "沙雕日常常驻观众",
    text: "本来只是想睡前刷两分钟，结果笑到室友以为我出了什么事。韩国歪歪漫画的段子太对我胃口了。",
    star: 5,
  },
  {
    name: "打工魂不灭",
    role: "神吐槽忠实粉丝",
    text: "周一的「精神续命」系列就是我本人，神吐槽看得我一边扎心一边爆笑，解压神器没跑了。",
    star: 5,
  },
  {
    name: "深夜摸鱼人",
    role: "梗图段子收集狂",
    text: "梗图质量很高，存图到手软。无厘头剧场那些毫无逻辑的剧情，偏偏让人停不下来，爱了。",
    star: 4,
  },
];